<template>
    <div v-if="apptsNumber.length > 1">
        <span class="coupon-label">
            {{ $t('coupon.totalApptBooked') }}
        </span>
        <span class="coupon-label">
            {{ apptsNumber.length }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'coupon-total-appt-booked',
    props: {
        apptsNumber: { type: Array, required: true },
    },
};
</script>

<style lang="scss" scoped>

</style>
